import { render } from "./NewLiveData.vue?vue&type=template&id=7abacb65&scoped=true&ts=true"
import script from "./NewLiveData.vue?vue&type=script&lang=ts"
export * from "./NewLiveData.vue?vue&type=script&lang=ts"

import "./NewLiveData.vue?vue&type=style&index=0&id=7abacb65&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abacb65"]])

export default __exports__